import { IconSVG } from '../types';

export const ChevronDown = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      style={style}
    >
      <path
        fill="currentColor"
        d="M20 24.959q-.334 0-.625-.104a1.5 1.5 0 0 1-.542-.355l-7.667-7.666q-.458-.459-.458-1.167t.458-1.167 1.167-.458 1.167.458L20 21l6.5-6.5q.458-.458 1.166-.458.709 0 1.167.458.459.459.458 1.167 0 .708-.458 1.167L21.166 24.5a1.5 1.5 0 0 1-.541.355q-.292.104-.625.104"
      />
    </svg>
  );
};
